import React from 'react';
import PropTypes from 'prop-types';

const ShareCount = ({ count }) => {
  if (!count) return null;
  return (
    <div className="flex flex-col justify-center items-center uppercase">
      <p className="text-xs font-bold">{count}</p>
      <p className="text-xs font-bold">shares</p>
    </div>
  );
};

ShareCount.propTypes = {
  count: PropTypes.number,
};

ShareCount.defaultProps = {
  count: 0,
};

export default ShareCount;
